import { render, staticRenderFns } from "./OrderStore.vue?vue&type=template&id=552373fa&scoped=true&"
import script from "./OrderStore.vue?vue&type=script&lang=js&"
export * from "./OrderStore.vue?vue&type=script&lang=js&"
import style0 from "./OrderStore.vue?vue&type=style&index=0&id=552373fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552373fa",
  null
  
)

export default component.exports